var React = require('react');

function Move (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillOpacity":".4","fillRule":"evenodd"},[React.createElement("circle",{"cx":"2","cy":"2","r":"2","key":0}),React.createElement("circle",{"cx":"2","cy":"10","r":"2","key":1}),React.createElement("circle",{"cx":"2","cy":"18","r":"2","key":2}),React.createElement("circle",{"cx":"2","cy":"26","r":"2","key":3}),React.createElement("circle",{"cx":"10","cy":"18","r":"2","key":4}),React.createElement("circle",{"cx":"10","cy":"10","r":"2","key":5}),React.createElement("circle",{"cx":"10","cy":"2","r":"2","key":6}),React.createElement("circle",{"cx":"10","cy":"26","r":"2","key":7})]));
}

Move.defaultProps = {"width":"12","height":"28","viewBox":"0 0 12 28"};

module.exports = Move;

Move.default = Move;
